export const adminNavSections = [
  {
    title: "Overview",
    items: [
      { label: "Dashboard", icon: "ri-dashboard-line", to: "/dashboard" },
    ],
  },
  {
    title: "Operations",
    items: [
      { label: "Projects", icon: "ri-truck-line", to: "/projects", badge: "14" },
      { label: "Bookings", icon: "ri-calendar-event-line", to: "/bookings", badge: "27" },
      { label: "Time Clock", icon: "ri-time-line", to: "/timeclock" },
    ],
  },
  {
    title: "People",
    items: [
      { label: "Crew", icon: "ri-team-line", to: "/crew" },
      { label: "Customers", icon: "ri-user-line", to: "/customers" },
    ],
  },
  {
    title: "Business",
    items: [
      { label: "Payments", icon: "ri-bank-card-line", to: "/payments" },
      { label: "Feedback", icon: "ri-star-line", to: "/feedback" },
    ],
  },
  {
    title: "System",
    items: [
      { label: "Public Site", icon: "ri-global-line", to: "/site" },
      { label: "Settings", icon: "ri-settings-3-line", to: "/settings" },
    ],
  },
];